import { BASE_PATH, BASE_URL } from '@/config/public';

const isInternalUrl = (url) => url && url.includes(`${BASE_URL}${BASE_PATH}`);

export default isInternalUrl;
